import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="bg-slate-900 border-t border-slate-800" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <h3 className="text-xl font-black text-white mb-3">ClubdoCupom<span className="text-amber-500">.com</span></h3>
            <p className="text-sm text-slate-400 leading-relaxed">
              O canal oficial do desconto direto. Conectamos lojistas e consumidores sem intermediários.
            </p>
          </div>

          {/* Navigation Links */}
          <div>
            <h4 className="text-sm font-bold text-slate-300 uppercase tracking-wider mb-4">Navegacao</h4>
            <nav className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-slate-400 hover:text-white transition-colors" data-testid="footer-link-home">Home</Link>
              <Link to="/categorias" className="text-sm text-slate-400 hover:text-white transition-colors" data-testid="footer-link-categorias">Categorias</Link>
              <Link to="/sobre-nos" className="text-sm text-slate-400 hover:text-white transition-colors" data-testid="footer-link-sobre">Sobre Nós</Link>
              <Link to="/politica-de-privacidade" className="text-sm text-slate-400 hover:text-white transition-colors" data-testid="footer-link-privacidade">Politica de Privacidade</Link>
              <a href="https://wa.me/5517981124597" target="_blank" rel="noopener noreferrer" className="text-sm text-slate-400 hover:text-white transition-colors" data-testid="footer-link-contato">Contato</a>
            </nav>
          </div>

          {/* Área do Lojista */}
          <div>
            <h4 className="text-sm font-bold text-slate-300 uppercase tracking-wider mb-4">Para Lojistas</h4>
            <nav className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-slate-400 hover:text-white transition-colors" data-testid="footer-link-lojista">Área do Lojista</Link>
            </nav>
          </div>
        </div>

        {/* Disclaimer + Copyright */}
        <div className="mt-8 pt-6 border-t border-slate-800">
          <p className="text-xs text-slate-500 text-center mb-2" data-testid="footer-disclaimer">
            As ofertas e cupons são de responsabilidade exclusiva dos lojistas assinantes.
          </p>
          <p className="text-xs text-slate-500 text-center" data-testid="footer-copyright">
            &copy; 2026 ClubdoCupom.com - Todos os direitos reservados. O canal oficial do desconto direto.
          </p>
        </div>
      </div>
    </footer>
  );
}
